module.exports = __webpack_public_path__ + "assets/img/banner1.1a29ae57.png";